import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Input, DatePicker, Form } from "antd";
import Api from "../../../../../services/ServiceApi";
import moment from "moment";

const BookingDocumentModal = ({ handleVisible, bookedData }) => {
  const [bookedDataTable, setBookingData] = useState(bookedData);
  const [init_ex_date, setinit_ex_date] = useState(null);
  const [init_in_date, setinit_in_date] = useState(null);

  const [customer, setcustomer] = useState("");
  const [project, setproject] = useState("");


  const [valueform, setValueform] = useState(null);

  const [checkCustomer, setcheckCustomer] = useState(false);
  const [checkProject, setcheckProject] = useState(false);
  const columns = [
    {
      title: "Plate No.",
      dataIndex: "license_plate",
      key: "license_plate",
    },
    {
      title: "Line No.",
      dataIndex: "bus_line_name",
      key: "bus_line_name",
    },
    {
      title: "Area",
      dataIndex: "area_name",
      key: "area_name",
    },
    {
      title: "Bus No.",
      dataIndex: "bus_no",
      key: "bus_no",
    },
    {
      title: "Model",
      dataIndex: "model_name",
      key: "model_name",
    },
    {
      title: "Action",
      dataIndex: "",
      key: "",
      render: (item) => (
        <button onClick={() => DeleteData(item)}>
          <img src={Api.absoluteUrl("/icon/delete.svg")} />
        </button>
      ),
    },
  ];
  const DeleteData = (item) => {
    const filteredItems = bookedDataTable.filter((data) => data.bus_id != item.bus_id);
    setBookingData([...filteredItems]);
  }
  const handleSubmit = (value) => {
    let arr_bus = []

    if (customer === "" || project === "") {
      if (customer === "") {
        setcheckCustomer(true);
      } else if (project === "") {
        setcheckProject(true);
      }

    }
    else {
      setcheckCustomer(false);
      setcheckProject(false);
      if (init_ex_date !== undefined || init_in_date !== undefined) {
        bookedDataTable.map((item, index) => (
          arr_bus.push(item.bus_id)
        ))
        const data_param = {
          bus_array: arr_bus,
          customer: customer,
          project_name: project,
          external_date: moment(init_ex_date).format("YYYY-MM-DD") === "Invalid date" ? null : moment(init_ex_date).format("YYYY-MM-DD"),
          internal_date: moment(init_in_date).format("YYYY-MM-DD") === "Invalid date" ? null : moment(init_in_date).format("YYYY-MM-DD")
        }

        Api.post("booking", data_param).then(res => {

          alert('booking complete')
          window.location.reload(false);
          handleVisible(false)

        })

      } else {
        console.log('false ,check validate form')
      }
    }



  }


  return (
    <>
      <Modal
        title="BOOKING DOCUMENT"
        visible={true}
        width={650}
        onCancel={() => handleVisible(false)}
        footer={false}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-6">
              <label className="labeaddjob font-thai-r font16"> Customer <b style={{ color: "rgb(223, 69, 71" }}> * </b> </label>

              <Input type="text" placeholder="Please Input" onChange={(e) => setcustomer(e.target.value)} ></Input>
              <br />
              <sapn class={checkCustomer ? "mr-2 mt-2 hideshow" : "divhide"} style={{ color: "red" }}>* Please Input Customer</sapn>
            </div>

            <div className="col-6">
              <label className="labeaddjob font-thai-r font16" > Project <b style={{ color: "rgb(223, 69, 71" }}> * </b> </label>
              <Input type="text" placeholder="Please Input" onChange={(e) => setproject(e.target.value)}></Input>
              <br />
              <sapn class={checkProject ? "mr-2 mt-2 hideshow" : "divhide"} style={{ color: "red" }}>* Please Input Project</sapn>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6">
              <label className="labeaddjob font-thai-r font16"> External Date </label>
              <br />
              <DatePicker placeholder="Start Date" style={{ width: "100%" }}
                onChange={(e) => setinit_ex_date(e)}
              />
            </div>
            <div className="col-6">
              <label className="labeaddjob font-thai-r font16" > Internal Date  </label>
              <br />
              <DatePicker placeholder="Start Date" style={{ width: "100%" }}
                onChange={(e) => setinit_in_date(e)}
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <Table columns={columns} dataSource={bookedDataTable} pagination={false} />

            </div>
            <div className="col-12 mt-2" style={{ textAlign: "center" }}>
              <button
                type="reset"
                onClick={() => handleVisible(false)}
                className="btn btn-secondary"
              >
                Cancel
            </button>
              <button type="submit" className="btn btn-warning"
                onClick={() => handleSubmit(valueform)}
              >Submit</button>
            </div>
          </div>
        </div>



      </Modal>
    </>
  );
};

export default BookingDocumentModal;
